import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "mdc-evolution-chip__cell mdc-evolution-chip__cell--primary",
  role: "gridcell"
}
const _hoisted_2 = {
  class: "mdc-evolution-chip__action mdc-evolution-chip__action--primary",
  type: "button"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "icon mdc-evolution-chip__icon--trailing icon-close ms-icon-close",
  textContent: 'close'
}
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["textContent"]

import type { IconFonts } from "@/types";

interface Props {
    label: string;
    value?: string | number;
    iconFont?: IconFonts;
    trailingIcon?: string;
    active?: null | boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MdcChip',
  props: {
    label: {},
    value: {},
    iconFont: { default: "ms" },
    trailingIcon: {},
    active: { type: [null, Boolean], default: null }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["mdc-evolution-chip", {
            'mdc-evolution-chip-active': props.active !== null && props.active,
        }]),
    role: "row"
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("button", _hoisted_2, [
        _createElementVNode("span", {
          class: "mdc-evolution-chip__text-label",
          innerHTML: props.label
        }, null, 8, _hoisted_3),
        (props.active !== null && props.active)
          ? (_openBlock(), _createElementBlock("i", _hoisted_4))
          : _createCommentVNode("", true),
        (props.trailingIcon && props.iconFont === 'ms')
          ? (_openBlock(), _createElementBlock("i", {
              key: 1,
              class: _normalizeClass(["material-symbols-outlined mdc-evolution-chip__icon--trailing", 'ms-icon-' + props.trailingIcon]),
              textContent: _toDisplayString(props.trailingIcon)
            }, null, 10, _hoisted_5))
          : _createCommentVNode("", true),
        (props.trailingIcon && props.iconFont !== 'ms')
          ? (_openBlock(), _createElementBlock("i", {
              key: 2,
              class: _normalizeClass(["mdc-evolution-chip__icon--trailing", props.iconFont + ' ' + props.trailingIcon]),
              textContent: _toDisplayString(props.trailingIcon)
            }, null, 10, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})